import React, { Component } from 'react';
import { Form, Input, Button } from 'reactstrap';
import { Redirect } from 'react-router-dom';
import './Login.css';

export default class Login extends Component {

	state = {
		token: undefined,
		email: undefined,
		inputEmail: true,
		remember: true,
		isLoggedIn: undefined
	}

	getLocalProfile = () => {
		var profileToken = localStorage.getItem("PROFILE_TOKEN");
		var profileReAuthEmail = localStorage.getItem("PROFILE_REAUTH_EMAIL");

		if ( profileReAuthEmail !== null && profileToken !== null) {
				this.setState({isLoggedIn: true});
		}
	}

	handleSignin = (e) => {
		e.preventDefault();
		localStorage.setItem("PROFILE_TOKEN", "demo-token");
		localStorage.setItem("PROFILE_REAUTH_EMAIL", e.target.elements.email.value || "demo@launsh.com");
		this.setState({isLoggedIn: true});
	}

	componentDidMount() {
		this.getLocalProfile();
	}

	render() {
		return this.state.isLoggedIn === true
			? <Redirect to='/admin' />
			: (
					<div className="container">
							<div className="card card-container">
								<img id="profile-img" className="profile-img-card" alt="" src="//ssl.gstatic.com/accounts/ui/avatar_2x.png"/>
								<div style={{background: '#fff3cd', color: '#856404', padding: '8px', marginBottom: '12px', borderRadius: '4px', fontSize: '13px', textAlign: 'center'}}>
									Demo mode — any email/password will work
								</div>
								<Form className="form-signin" onSubmit={this.handleSignin}>
									<span className="reauth-email">{this.state.email}</span>
									<Input type="email" name="email" className="form-control" placeholder="Email address" required autoFocus></Input>
									<Input type="password" name="password" className="form-control" placeholder="Password" required></Input>
									<Button color="primary" size="large" className="btn btn-signin" type="submit" block>Sign in</Button>
								</Form>
								<Button className="login-link" color="link">Forgot your password?</Button>
							</div>
					</div>
				)
	}
}
